import React from 'react';
import PropTypes from "prop-types";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import {CheckboxContent, ComponentDivider, CheckboxWrapper,  FormWrapper, CapsuleButtonWrapper} from '../styles';
import TooltipComponent from "../../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import{ CustomCheckbox } from "../../../../../../../../src/CommonComponents/commonStyles";
import { Form, Checkbox } from 'antd';
import { ContentContainerSpaceSmall} from "../../../styles";
import AOMutualFundAccount from './AOMutualFundAccount';
import { addMutualFund,checkVGMutualFund } from "../../../actions";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import {defaultMutualFundAHOV,defaultSecurityGiftAHOV} from "../../CommonComponents/Data";
import { assetHeldOutsideVanguardState } from "../../../selectors";
import Notice from './Notice';

class AssetHeldOutsideVanguard extends React.Component {
    constructor(props) {
        super(props);
        this.addAnotherMF = this.addAnotherMF.bind(this);
        this.addAnotherSG = this.addAnotherSG.bind(this);
        this.removeMfAccount = this.removeMfAccount.bind(this);
        this.removeSgAccount = this.removeSgAccount.bind(this);
    }

    addAnotherMF = (e) => {
        let storeData = this.props.mfAccountDetails;
        if (storeData.length < 20)
        {
        let emptyOb = JSON.parse(JSON.stringify(defaultMutualFundAHOV[0]));
        let loggedInAddress = this.props.loggedInAddress;
            emptyOb.Donors[0] = loggedInAddress;
        Array.prototype.push2 = function (x) {
            this.push(x);
            return this;
        };
        let updatedData = storeData.push2(emptyOb);
        this.props.addMutualAccount(updatedData);
    }
    }
 
    addAnotherSG = (e) => {
        let storeData = this.props.sgAccountDetails;
        if (storeData.length < 20)
        {
        let emptyOb = JSON.parse(JSON.stringify(defaultSecurityGiftAHOV[0]));
        let loggedInAddress = this.props.loggedInAddress;
            emptyOb.Donors[0] = loggedInAddress;
        Array.prototype.push2 = function (x) {
            this.push(x);
            return this;
        };
        let updatedData = storeData.push2(emptyOb);
        this.props.addSecurityGift(updatedData);
    }
    }

    removeMfAccount = (index) => {
        let storeData = this.props.mfAccountDetails;
        storeData.splice(index,1);
        this.props.addMutualAccount(storeData);
    }

    removeSgAccount = (index) => {
        let storeData = this.props.sgAccountDetails;
        storeData.splice(index,1);
        this.props.addSecurityGift(storeData);
    }

    render() {
        return (
            <ContentContainerSpaceSmall data-test="assetHeldOutsideVanguard">
            <div className="fluid">
                <CheckboxWrapper mb="20px" marginBottom="30px"><CustomCheckbox onChange={this.props.checkVGFund} id={this.props.id && ("chkMutualFundGift"+this.props.id)} checked={this.props.isVGselected}></CustomCheckbox><CheckboxContent marginLeft="15px">Enter a Mutual Fund Gift</CheckboxContent> </CheckboxWrapper>
                { (this.props.isVGselected === true) ?
                <FormWrapper>
                    <Notice message = {`<div>To verify that the mutual fund you wish to contribute is transferable to VC go to <a target = new href ="https://investor.vanguard.com/other-funds/" >vanguard.com </a> and search for the ticker symbol or fund name. If a yellow banner states the fund is not available for transfer, <a href = "mailto:donorservice@vanguardcharitable.org">contact us.</a> If no banner appears, please continue to enter the needed information to complete your contribution.</div>`}> </Notice> 
                    {Array.prototype.map.call(this.props.mfAccountDetails, (account,index) => (
                        <>
                            <AOMutualFundAccount assetHeld="assetOutsideVG" accountId={index} count={this.props.mfAccountDetails.length} type={account.type} contributionType="mutualFund" count={this.props.mfAccountDetails.length-1}/>
                            {(index !== 0) ?
                                <CapsuleButtonWrapper marginBottom="30px" marginRight="20px">
                                <CapsuleButton
                                    data-test="removeBtn"
                                    text= "Remove Account"
                                    id={"button"+index} 
                                    onClick={e => this.removeMfAccount(index)}
                                />
                                </CapsuleButtonWrapper>
                                : null
                            }
                            {((index) < (this.props.mfAccountDetails.length-1)) ?
                                <ComponentDivider marginTop="10px" marginBottom="40px" mT="0px" mB="40px"/>
                                : null
                            }
                        </>
                    ))}
                    <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton
                        data-test="addaccount-block"
                        text= "Add another account"
                        iconType="add"
                        padding="5px 20px"
                        disabled={this.props.mfAccountDetails.length === 20 ? true : false} 
                        onClick={e => this.addAnotherMF(e)} 
                        id={this.props.id&&("btnAddAnotherAccount"+this.props.id)}
                    />
                    </CapsuleButtonWrapper>
                </FormWrapper>
                : ""}
                <ComponentDivider />
                <CheckboxWrapper mb="20px" marginBottom="30px"><CustomCheckbox onChange={this.props.checkSGFund} checked={this.props.isSGselected} id={this.props.id &&( "chkSecurityGift"+this.props.id)}></CustomCheckbox><CheckboxContent marginLeft="15px">Enter a Security Gift </CheckboxContent> </CheckboxWrapper>
                { (this.props.isSGselected === true) ?
                <FormWrapper>
                    {Array.prototype.map.call(this.props.sgAccountDetails, (account,index) => (
                        <>
                            <AOMutualFundAccount assetHeld="assetOutsideVG" accountId={index} count={this.props.sgAccountDetails.length} type={account.type} contributionType="securityGift" count={this.props.sgAccountDetails.length-1}/>
                            {(index !== 0) ?
                                <CapsuleButtonWrapper marginBottom="30px" marginRight="20px">
                                <CapsuleButton
                                    data-test="removeBtnsgDetails"
                                    text= "Remove Account"
                                    id={"button"+index} 
                                    onClick={e => this.removeSgAccount(index)}
                                />
                                </CapsuleButtonWrapper>
                                : null
                            }
                            {(index < (this.props.sgAccountDetails.length-1)) ?
                                <ComponentDivider marginTop="10px" marginBottom="40px" mT="0px" mB="40px"/>
                                : null
                            }
                        </>
                    ))}
                    <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton
                        data-test="addaccountDetailsSg"
                        text= "Add another account"
                        iconType="add"
                        padding="5px 20px"
                        disabled={this.props.sgAccountDetails.length === 20 ? true : false} 
                        onClick={e => this.addAnotherSG(e)} 
                        id={this.props.id && ("btnAddAnotherAccount2"+this.props.id)}
                    />
                    </CapsuleButtonWrapper>
                </FormWrapper>
                : ""}
            </div>
            </ContentContainerSpaceSmall>
            
        )
    }
}

const WrappedForm = Form.create({ name: "AssetHeldOutsideVanguard" })(AssetHeldOutsideVanguard);

WrappedForm.propTypes = {
    mfAccountDetails: PropTypes.object,
    sgAccountDetails: PropTypes.object,
    isVGselected: PropTypes.bool,
    isSGselected: PropTypes.bool,
    loggedInAddress: PropTypes.object,
    addMutualAccount: PropTypes.func,
    addSecurityGift: PropTypes.func,
    checkVGFund: PropTypes.func,
    checkSGFund: PropTypes.func
}

const mapStateToProps = state => ({
    ...assetHeldOutsideVanguardState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
    addMutualAccount: arr => dispatch(addMutualFund({value: arr, contributionType: "mutualFund", assetHeld:"assetOutsideVG", selected:'mfSelected'})),
    addSecurityGift: arr => dispatch(addMutualFund({value: arr, contributionType: "securityGift", assetHeld:"assetOutsideVG", selected:'sgSelected'})),
    checkVGFund: e => dispatch(checkVGMutualFund({value: e.target.checked,property: "mfSelected", assetHeld:"assetOutsideVG"})),
    checkSGFund: e => dispatch(checkVGMutualFund({value: e.target.checked,property: "sgSelected", assetHeld:"assetOutsideVG"}))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedForm));